import React, { useState, useEffect } from "react";
import { Table, Button, FormControl } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import CONFIG from "../config";
import { usePatient } from "../context/PatientContext";
import "../Styles/doctorlist.css";

const ListofDoctors = () => {
  const [doctors, setDoctors] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [clinics, setClinics] = useState({});

  const navigate = useNavigate();
  const baseURL = CONFIG.BASE_URL ;
  const token = localStorage.getItem("authToken");

  const { doctorInfo } = usePatient();
   

  useEffect(() => {
//    axios.get(`${baseURL}/doctors`)
axios.get(`${baseURL}/doctors`, {
  headers: {
    Authorization: `Bearer ${token}`,        // 🔐 JWT Token
    doctorId: doctorInfo.MANDALI_ID,       // 🧑‍⚕️ Custom context
    clinicId: doctorInfo.CLINIC_ID,
    roleId: doctorInfo.MANDALI_ROLE
  }
})
      .then((res) => {
        // Filter doctors with MANDALI_ROLE === 2
        const filteredDoctors = res.data.filter(doctor => doctor.MANDALI_ROLE === 2);
        setDoctors(filteredDoctors);
      })
      .catch(err => {
        console.error("Error fetching doctors:", err);
      });
      
   //   axios.get(`${baseURL}/doctors/clinics`)
axios.get(`${baseURL}/doctors/clinics`, {
    headers: {
      Authorization: `Bearer ${token}`,        // 🔐 JWT Token
      doctorId: doctorInfo.MANDALI_ID,       // 🧑‍⚕️ Custom context
      clinicId: doctorInfo.CLINIC_ID,
      roleId: doctorInfo.MANDALI_ROLE
    }
  })
    .then((res) => {
      // Store clinics in an object with CLINIC_ID as the key
      const clinicsMap = {};
      res.data.forEach(clinic => {
        clinicsMap[clinic.CLINIC_ID] = clinic.CLINIC_NAME;
      });
      setClinics(clinicsMap);
    })
    .catch(err => console.error("Error fetching clinics:", err));
}, []);

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  // Filter by search term (Doctor Name or Clinic Name)
  const filteredDoctors = doctors.filter((doc) =>
    doc.MANDALI_FULL_NAME?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    doc.CLINIC_NAME?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="doctor-list-container">
    <h1 className="doctor-list-title">Doctor List</h1>

    <FormControl
      type="text"
      placeholder="Search by Doctor Name"
      value={searchTerm}
      onChange={handleSearch}
      className="doctor-search-input"
    />

    <div className="doctor-buttons mb-3">
      <Button onClick={() => navigate("/add-clinic")} className="green-btn me-2">
        Add Clinic
      </Button>
      <Button onClick={() => navigate("/add-doctor")} className="green-btn">
        Add Doctor
      </Button>
      <Button onClick={() => navigate("/add-attendant")} className="green-btn">
        Add Attendant
      </Button>
    </div>

    <Table bordered responsive className="doctor-table">
      <thead>
        <tr>
          <th>Doctor Name</th>
          <th>Clinic Name</th>
        </tr>
      </thead>
      <tbody>
        {filteredDoctors.length > 0 ? (
          filteredDoctors.map((doctor) => (
            <tr key={doctor.MANDALI_ID}>
              <td>
                <button
                  className="link-button"
                  onClick={() => navigate(`/edit-doctor/${doctor.MANDALI_ID}`)}
                >
                  {doctor.MANDALI_FULL_NAME}
                </button>
              </td>
              <td>{clinics[doctor.CLINIC_ID] || "Unknown Clinic"}</td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan="2" className="text-center">
              No doctors found.
            </td>
          </tr>
        )}
      </tbody>
    </Table>
  </div>
  );
};

export default ListofDoctors;
